import { createContext, ReactElement, ReactNode, useContext, useMemo } from 'react'

import { InvoiceLine } from '../../../types/invoices/invoiceLine'

interface ContextState {
  quoteCurrency: string
  quoteLines: InvoiceLine[]
  quoteLocale: string
}

const DepositInvoiceDetailsModalContext = createContext<ContextState | undefined>(undefined)

interface DepositInvoiceDetailsModalContextProviderProps {
  children?: ReactNode
  quoteCurrency: string
  quoteLines: InvoiceLine[]
  quoteLocale: string
}

export const DepositInvoiceDetailsModalContextProvider = ({
  children,
  quoteCurrency,
  quoteLines,
  quoteLocale,
}: DepositInvoiceDetailsModalContextProviderProps): ReactElement => {
  const contextValue = useMemo(
    () => ({ quoteCurrency, quoteLines, quoteLocale }),
    [quoteCurrency, quoteLines, quoteLocale],
  )

  return (
    <DepositInvoiceDetailsModalContext.Provider value={contextValue}>
      {children}
    </DepositInvoiceDetailsModalContext.Provider>
  )
}

export const useDepositInvoiceDetailsModal = () => {
  const context = useContext(DepositInvoiceDetailsModalContext)

  if (!context) {
    throw new Error('DepositInvoiceDetailsModalContextProvider is missing in the module!')
  }

  return context
}
